import { ExamInterface, ObjectiveInterface } from "../../../interfaces/examInterfaces";
import { DIALOGS } from "../../Dialogs/dialogReducer";
import { Tab } from "../Reducers/ManipulateObjectivesReducer";
import {
  addObjectiveCopy,
  handleCloseDialog,
  handleOpenDialog,
  removeObjectiveCopy,
  resetDataPages,
  setActiveTab,
  setExamData,
  setFirstPageLoad,
  setMappedTabs,
  setSelectedObjectiveId,
} from "./FunctionsMain";

export function createTabs(sortedObjectives: ObjectiveInterface[]) {
  const mappedTabs = sortedObjectives.map((objective) => ({
    id: objective.id,
    label: `${objective.topic} K${objective.objectiveIndex}`,
  }));
  setMappedTabs(mappedTabs);
  setActiveTab(0);
  setFirstObjectiveId(sortedObjectives);
}

function setFirstObjectiveId(sortedObjectives: ObjectiveInterface[]) {
  const firstSelectedObejective = sortedObjectives[0].id;
  setSelectedObjectiveId(firstSelectedObejective);
}

export function updateObjectives(objectivesCopy: { [key: string]: ObjectiveInterface }, examData: ExamInterface) {
  if (Object.keys(objectivesCopy).length === 0) {
    handleOpenDialog(DIALOGS.NO_OBJECTIVE_SELECTED_DIALOG);
    return;
  }
  const syncedObjectives = syncObjectives(examData, objectivesCopy);
  resetDataPages();
  const firstObjectiveId = Object.keys(syncedObjectives)[0];
  setSelectedObjectiveId(firstObjectiveId);
  setFirstPageLoad(true);
  setExamData(
    {
      objectives: syncedObjectives,
    },
    examData
  );
  handleCloseDialog(DIALOGS.SELECT_TOPICS_EXAM_DIALOG);
}

function syncObjectives(examData: ExamInterface, objectivesCopy: { [key: string]: ObjectiveInterface }) {
  const examBuilderDataObjectives = examData.objectives;
  const updatedObjectives = { ...objectivesCopy };

  Object.keys(objectivesCopy).forEach((key) => {
    if (examBuilderDataObjectives[key]) {
      updatedObjectives[key] = examBuilderDataObjectives[key];
    }
  });
  return updatedObjectives;
}

export function addObjective(objective: ObjectiveInterface) {
  addObjectiveCopy(objective);
}

export function removeObjective(objectiveId: number) {
  removeObjectiveCopy(objectiveId);
}

export function checkObjectivesSelected(sortedObjectives: ObjectiveInterface[]) {
  if (sortedObjectives.length === 0) {
    handleOpenDialog(DIALOGS.SELECT_TOPICS_EXAM_DIALOG);
  }
}

export function closeSelectObjectivesDialog(sortedObjectives: ObjectiveInterface[]) {
  if (sortedObjectives.length === 0) {
    handleOpenDialog(DIALOGS.NO_OBJECTIVE_SELECTED_DIALOG);
  } else {
    handleCloseDialog(DIALOGS.SELECT_TOPICS_EXAM_DIALOG);
  }
}

export function handleConfirmNoObjectiveSelected() {
  handleCloseDialog(DIALOGS.NO_OBJECTIVE_SELECTED_DIALOG);
}

export function deleteObjective(
  objectiveId: string,
  selectedTabIndex: number,
  selectedObjectiveId: string,
  examData: ExamInterface,
  tabs: Tab[],
  activeTab: number
) {
  if (objectiveId === selectedObjectiveId) {
    resetDataPages();
    const firstObjectiveId = Object.keys(examData.objectives)[0];
    setSelectedObjectiveId(firstObjectiveId);
    setActiveTab(0);
    setFirstPageLoad(true);
  }
  const updatedObjectives = { ...examData.objectives };
  delete updatedObjectives[objectiveId];
  setExamData(
    {
      ...examData,
      objectives: updatedObjectives,
    },
    examData
  );

  if (Object.keys(updatedObjectives).length === 0) {
    handleOpenDialog(DIALOGS.SELECT_TOPICS_EXAM_DIALOG);
  }

  if (tabs) {
    if (tabs.length === activeTab + 1) {
      setActiveTab(activeTab - 1);
    }
    if (selectedTabIndex < activeTab) {
      setActiveTab(activeTab - 1);
    }
    const updatedTabs = tabs.filter((_, index) => index !== selectedTabIndex);
    setMappedTabs(updatedTabs);
  }
}
